<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6" md="3" class="py-1">
        <label for="kv">KV</label>
        <input
          type="text"
          id="kv"
          v-model="formData.kv"
          @blur="updateVessel"
          disabled
        />
      </v-col>
      <v-col cols="12" sm="6" md="3" class="py-1">
        <label for="nama_kapal">Nama Kapal</label>
        <input
          type="text"
          id="nama_kapal"
          v-model="formData.nama_kapal"
          @blur="updateVessel"
          @keydown.enter="focusRefs('tgl_berangkat')"
          ref="nama_kapal"
        />
      </v-col>
      <v-col cols="12" sm="6" md="3" class="py-1">
        <label for="tgl_berangkat">Tanggal Berangkat</label>
        <input
          type="date"
          id="tgl_berangkat"
          v-model="formData.tgl_berangkat"
          @blur="updateVessel"
          @keydown.enter="focusRefs('voy1')"
          ref="tgl_berangkat"
        />
      </v-col>
      <v-col cols="12" sm="6" md="3" class="py-1">
        <label for="voy1">Voy</label>
        <div class="flex">
          <input
            type="text"
            id="voy1"
            v-model="formData.voy1"
            @blur="updateVessel"
            @keydown.enter="focusRefs('voy2')"
            ref="voy1"
          />
          <p class="my-auto separator">/</p>
          <input
            type="text"
            id="voy2"
            v-model="formData.voy2"
            @blur="updateVessel"
            @keydown.enter="createVessel"
            ref="voy2"
          />
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="12" md="8">
        <v-data-table
          :headers="containerHeaders"
          :items="containers"
          :loading="loading.container"
          :items-per-page="-1"
          :sort-by="['demurage']"
          :sort-desc="[true]"
          height="400px"
          class="elevation-1 mt-2"
          dense
        >
          <!-- <template v-slot:item.demurage="{ item }">
            {{ calculateDemurage(item.tgl_stuffing) }}
          </template> -->
          <template v-slot:item.kv="{ item }">
            <v-text-field
              dense
              hide-details
              class="pa-0 ma-0"
              @keydown.enter="updateKV($event, item.kc)"
            ></v-text-field>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <v-data-table
          :headers="vesselHeaders"
          :items="vessels"
          :loading="loading.vessel"
          :items-per-page="5"
          class="elevation-1 mt-2"
          dense
        ></v-data-table>
      </v-col>
    </v-row>

    <VesselModal :openModal="openModal" @close-modal="closeModal" />

    <!-- Save Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="closeVessel"
    >
      New
      <!-- <v-icon dark>
        mdi-file
      </v-icon> -->
    </v-btn>
  </v-container>
</template>

<script>
import axios from "axios";
import { sync } from "vuex-pathify";

export default {
  name: "VesselView",
  components: {
    VesselModal: () => import("@/components/Vessel/VesselModal.vue")
  },
  data() {
    return {
      openModal: true,
      formData: {
        kv: "",
        nama_kapal: "",
        tgl_berangkat: "",
        voy1: "",
        voy2: ""
      },
      loading: {
        container: false,
        vessel: false
      },
      vesselHeaders: [
        { text: "Tgl Berangkat", value: "tgl_berangkat" },
        { text: "KV", value: "kv" },
        { text: "Vessel", value: "vessel" }
      ],
      containerHeaders: [
        { text: "KV", value: "kv", width: "100px" },
        { text: "NoCont", value: "no_container" },
        { text: "Seal", value: "no_seal" },
        { text: "KC", value: "kc" },
        { text: "TglStuffing", value: "tgl_stuffing" },
        { text: "Demurage", value: "demurage" },
        { text: "Cargo", value: "cargo" },
        { text: "JenisCont", value: "jenis_container" },
        { text: "PrioritasBerangkat", value: "prioritas_berangkat" }
      ],
      vessels: [],
      containers: []
    };
  },
  computed: {
    mini: sync("app/mini")
  },
  methods: {
    closeModal(data) {
      this.openModal = false;
      this.mini = true;

      if (data) {
        this.formData.kv = data.kv;
        this.formData.nama_kapal = data.nama_kapal;
        this.formData.tgl_berangkat = data.tgl_berangkat;
        this.formData.voy1 = data.voy.split("/")[0];
        this.formData.voy2 = data.voy.split("/")[1];
      }
    },
    async updateKV(event, id) {
      await axios
        .put(`update-container/kv?kc=${id}&kv=${event.target.value}`)
        .then(res => {
          this.fetchContainer();
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchVessel() {
      this.loading.vessel = true;

      await axios
        .get(`vessel`)
        .then(res => {
          this.vessels = res.data;

          this.loading.vessel = false;
        })
        .catch(err => {
          this.loading.vessel = false;

          alert(err.response.data.message);
        });
    },
    async fetchContainer() {
      this.loading.container = true;

      await axios
        .get(`container-belum-berangkat`)
        .then(res => {
          this.containers = res.data;

          this.loading.container = false;
        })
        .catch(err => {
          this.loading.container = false;

          alert(err.response.data.message);
        });
    },
    closeVessel() {
      this.resetForm();
      this.openModal = true;
    },
    async updateVessel() {
      if (!this.formData.kv) return;

      await axios
        .put(`vessel/${this.formData.kv}`, this.formData)
        .then(res => {})
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    calculateDemurage(date) {
      let date1 = new Date(date);
      let date2 = new Date();

      // The number of milliseconds in one day
      const ONE_DAY = 1000 * 60 * 60 * 24;

      // Calculate the difference in milliseconds
      const differenceMs = Math.abs(date1 - date2);

      // Convert back to days and return
      return Math.round(differenceMs / ONE_DAY);
    },
    focusRefs(id) {
      this.$refs[id].focus();
    },
    resetForm() {
      this.formData = {
        kv: "",
        nama_kapal: "",
        tgl_berangkat: "",
        voy1: "",
        voy2: ""
      };
    }
  },
  created() {
    this.fetchContainer();
    this.fetchVessel();
  },
  mounted() {
    this.focusRefs("nama_kapal");
  }
};
</script>

<style scoped>
input {
  width: 100%;
  background-color: white;
  padding: 0 5px;
}

.flex {
  display: flex;
}

.separator {
  padding: 0 5px;
}
</style>
